import React from "react";
import { CAMERA_MODES } from "../../lib/gamecraft";

export default function CameraModePicker({ value, onChange }) {
  const current = value === "topdown" ? "topdown" : "side";
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
      {CAMERA_MODES.map((m) => {
        const on = current === m.id;
        return (
          <button
            key={m.id}
            type="button"
            onClick={() => onChange(m.id)}
            className="rounded-2xl p-3 text-left border"
            style={{
              borderColor: on ? "var(--gc-primary)" : "var(--gc-border)",
              background: on ? "var(--gc-primary-soft)" : "var(--gc-surface)",
            }}
          >
            <div className="flex items-center justify-between gap-2">
              <div className="font-semibold text-sm">{m.name}</div>
              <span className="gc-chip">{m.tag}</span>
            </div>
            <p className="text-[11px] mt-1" style={{ color: "var(--gc-muted)" }}>{m.hint}</p>
          </button>
        );
      })}
    </div>
  );
}
